import type { MittwaldAPIV2Client } from "@mittwald/api-client-NEXT";
import { assertStatus } from "@mittwald/api-client-NEXT";
import type { MySqlUserBehaviors } from "./types.js";
import { checkForValidationErrors } from "../../../base/index.js";

export const apiMySqlUserBehaviors = (
  client: MittwaldAPIV2Client,
): MySqlUserBehaviors => ({
  find: async (mysqlUserId) => {
    const response = await client.database.getMysqlUser({ mysqlUserId });

    if (response.status === 200) {
      return response.data;
    }
    assertStatus(response, 404);
  },

  list: async (databaseId) => {
    const response = await client.database.listMysqlUsers({
      mysqlDatabaseId: databaseId,
    });

    assertStatus(response, 200);

    return {
      items: response.data,
    };
  },

  create: async (mySqlDatabaseId, data) => {
    const response = await client.database.createMysqlUser({
      mysqlDatabaseId: mySqlDatabaseId,
      data,
    });

    const validationErrors = checkForValidationErrors(response);
    if (validationErrors) {
      return validationErrors;
    }

    assertStatus(response, 201);
    return response.data;
  },

  getPhpMyAdminUrl: async (mysqlUserId) => {
    const response = await client.database.getMysqlUserPhpMyAdminUrl({
      mysqlUserId,
    });

    assertStatus(response, 200);

    return response.data.url;
  },

  delete: async (mysqlUserId) => {
    const response = await client.database.deleteMysqlUser({ mysqlUserId });
    assertStatus(response, 204);
  },

  updatePassword: async (mysqlUserId, password) => {
    const response = await client.database.updateMysqlUserPassword({
      mysqlUserId,
      data: { password },
    });
    assertStatus(response, 204);
  },

  update: async (mysqlUserId, data) => {
    const response = await client.database.updateMysqlUser({
      mysqlUserId,
      data,
    });
    assertStatus(response, 204);
  },
});
